import { RouteRecordRaw } from 'vue-router'
const routes: Array<RouteRecordRaw> = [
	{
		path: 'knowledgeList',
		name: 'KnowledgeList',
		meta: { title: '文档管理', rootRoute: '/home' },
		component: () => import('@/views/doc-mgt/knowledgeList.vue')
	}
]

export default routes
